module.exports = __webpack_public_path__ + "img/m-guide-sites.e494d0c2.png";